export const ASSET_COLLECTION = 'assets';



// WEBPACK FOOTER //
// ./src/js/assets/domain/config.js